export const BrandedDivider = () => {
  return (
    <svg viewBox="0 0 1600 157" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <mask id="path-1-inside-1_6449_68769" fill="white">
        <path d="M0 0H1600V157H0V0Z" />
      </mask>
      <g clipPath="url(#clip0_6449_68769)">
        <mask id="path-3-inside-2_6449_68769" fill="white">
          <path d="M0 20H1600V157H0V20Z" />
        </mask>
        <mask
          id="mask0_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="842"
          y="69"
          width="156"
          height="178"
        >
          <path
            d="M923.953 245.881C921.736 247.162 919.004 247.162 916.786 245.881L846.374 205.229C844.157 203.949 842.791 201.583 842.791 199.022L842.791 117.717C842.791 115.157 844.157 112.791 846.374 111.511L916.786 70.8579C919.004 69.5778 921.736 69.5778 923.953 70.8579L994.365 111.511C996.583 112.791 997.949 115.157 997.949 117.717L997.949 199.022C997.949 201.583 996.583 203.949 994.365 205.229L923.953 245.881Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_6449_68769)">
          <rect
            width="89.5805"
            height="89.5805"
            transform="matrix(-0.866025 -0.5 8.74228e-08 -1 997.996 203.129)"
            fill="url(#paint0_linear_6449_68769)"
          />
          <rect
            width="89.5805"
            height="89.5805"
            transform="matrix(-0.866025 -0.5 8.74228e-08 -1 997.996 203.129)"
            fill="url(#paint1_linear_6449_68769)"
          />
          <g filter="url(#filter0_i_6449_68769)">
            <rect
              width="89.5805"
              height="89.5805"
              rx="3.58322"
              transform="matrix(-0.866026 0.5 8.74228e-08 -1 920.39 158.34)"
              fill="#BFFFD1"
            />
          </g>
        </g>
        <g filter="url(#filter1_f_6449_68769)">
          <path
            d="M794.596 138.682C752.977 143.141 713.538 124.016 701.845 115.494L708.98 94.0898C717.898 104.197 745.248 124.115 775.57 131.25C806.955 138.635 846.631 125.302 871.619 115.599C871.712 115.562 871.802 115.527 871.889 115.494C871.799 115.529 871.709 115.564 871.619 115.599C864.057 118.596 835.708 134.277 794.596 138.682Z"
            fill="url(#paint2_linear_6449_68769)"
          />
        </g>
        <g filter="url(#filter2_f_6449_68769)">
          <path
            d="M761.894 134.519C761.894 134.519 727.112 124.952 703.627 112.818L711.059 103.602C740.388 127.384 761.894 134.519 761.894 134.519Z"
            fill="#3094FF"
          />
        </g>
        <path
          d="M679.253 110.045L689.923 115.575L693.92 114.984C698.12 111.275 706.637 103.698 707.105 103.061C707.691 102.265 715.683 92.1332 715.861 91.606C716.04 91.0788 717.553 76.4505 717.081 76.1776C716.608 75.9047 715.609 72.1772 715.137 71.9043C714.759 71.6861 712.195 68.7774 710.96 67.3504C708.033 65.8707 702.085 62.8567 701.707 62.6384L697.832 60.4009L697.177 61.5352L696.474 64.2803L692.702 69.2863L686.279 73.6442L683.297 74.4432L684.259 77.1416L684.742 81.3271L682.339 88.7626L678.403 94.0521L673.486 97.7668L670.26 98.5512L669.033 103.514L679.253 110.045Z"
          fill="url(#paint3_linear_6449_68769)"
        />
        <path
          d="M679.253 110.045L689.923 115.575L693.92 114.984C698.12 111.275 706.637 103.698 707.105 103.061C707.691 102.265 715.683 92.1332 715.861 91.606C716.04 91.0788 717.553 76.4505 717.081 76.1776C716.608 75.9047 715.609 72.1772 715.137 71.9043C714.759 71.6861 712.195 68.7774 710.96 67.3504C708.033 65.8707 702.085 62.8567 701.707 62.6384L697.832 60.4009L697.177 61.5352L696.474 64.2803L692.702 69.2863L686.279 73.6442L683.297 74.4432L684.259 77.1416L684.742 81.3271L682.339 88.7626L678.403 94.0521L673.486 97.7668L670.26 98.5512L669.033 103.514L679.253 110.045Z"
          fill="url(#paint4_linear_6449_68769)"
        />
        <mask
          id="mask1_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="669"
          y="60"
          width="49"
          height="56"
        >
          <path
            d="M679.251 110.044L689.921 115.575L693.918 114.983C698.118 111.275 706.635 103.698 707.103 103.061C707.689 102.264 715.681 92.1327 715.859 91.6055C716.038 91.0783 717.551 76.45 717.079 76.1771C716.606 75.9043 715.607 72.1767 715.135 71.9039C714.757 71.6856 712.193 68.7769 710.958 67.3499C708.031 65.8702 702.083 62.8562 701.705 62.6379L697.83 60.4004L697.175 61.5347L696.472 64.2799L692.7 69.2858L686.277 73.6437L683.295 74.4427L684.257 77.1411L684.74 81.3267L682.337 88.7621L678.401 94.0516L673.484 97.7663L670.258 98.5507L669.031 103.514L679.251 110.044Z"
            fill="url(#paint5_linear_6449_68769)"
          />
          <path
            d="M679.251 110.044L689.921 115.575L693.918 114.983C698.118 111.275 706.635 103.698 707.103 103.061C707.689 102.264 715.681 92.1327 715.859 91.6055C716.038 91.0783 717.551 76.45 717.079 76.1771C716.606 75.9043 715.607 72.1767 715.135 71.9039C714.757 71.6856 712.193 68.7769 710.958 67.3499C708.031 65.8702 702.083 62.8562 701.705 62.6379L697.83 60.4004L697.175 61.5347L696.472 64.2799L692.7 69.2858L686.277 73.6437L683.295 74.4427L684.257 77.1411L684.74 81.3267L682.337 88.7621L678.401 94.0516L673.484 97.7663L670.258 98.5507L669.031 103.514L679.251 110.044Z"
            fill="url(#paint6_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask1_6449_68769)">
          <g opacity="0.96" filter="url(#filter3_f_6449_68769)">
            <path
              d="M688.469 98.9181L694.975 102.29L697.411 101.93C699.972 99.6697 705.163 95.0519 705.449 94.6637C705.806 94.1785 710.678 88.0033 710.786 87.682C710.895 87.3606 711.817 78.444 711.528 78.2776C711.24 78.1112 710.631 75.839 710.343 75.6726C710.112 75.5395 708.549 73.7663 707.796 72.8963C706.012 71.9941 702.385 70.1564 702.154 70.0233L699.791 68.659L699.392 69.3504L698.964 71.0236L696.665 74.0747L692.749 76.7305L690.931 77.2173L691.518 78.8622L691.813 81.4136L690.349 85.9457L687.95 89.1696L684.952 91.4335L682.986 91.9113L682.238 94.9365L688.469 98.9181Z"
              fill="#0527FC"
            />
          </g>
        </g>
        <g opacity="0.69" filter="url(#filter4_f_6449_68769)">
          <path
            d="M683.77 89.4006C679.112 99.2142 670.029 102.284 666.695 102.166L669.96 62.0186L696.415 58.7653C697.439 59.9026 698.831 64.1987 693.939 70.6952C690.394 75.4031 685.47 76.9828 682.923 76.3702C685.203 77.6606 687.778 80.9552 683.77 89.4006Z"
            fill="#000240"
          />
        </g>
        <path
          d="M703.692 114.862L702.434 114.64L706.399 108.863L707.944 108.589C706.885 110.278 704.671 113.789 704.287 114.323C703.903 114.858 703.759 114.911 703.692 114.862Z"
          fill="url(#paint7_linear_6449_68769)"
        />
        <path
          d="M701.955 115.308C699.591 117.876 698.836 118.255 698.755 118.124L697.986 117.491L706.318 108.406L707.5 109.088C706.166 110.744 704.911 112.099 701.955 115.308Z"
          fill="url(#paint8_linear_6449_68769)"
        />
        <path
          d="M706.556 58.822C704.117 57.8069 701.109 57.7248 698.762 57.9141L714.039 67.3642C713.915 66.7048 713.304 64.8604 711.846 62.7582C710.023 60.1304 708.512 59.6363 706.556 58.822Z"
          fill="url(#paint9_linear_6449_68769)"
        />
        <mask
          id="mask2_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="698"
          y="57"
          width="17"
          height="11"
        >
          <path
            d="M706.56 58.822C704.121 57.8069 701.112 57.7248 698.766 57.9141L714.042 67.3642C713.919 66.7048 713.307 64.8604 711.849 62.7582C710.026 60.1304 708.516 59.6363 706.56 58.822Z"
            fill="url(#paint10_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask2_6449_68769)">
          <g opacity="0.68" filter="url(#filter5_f_6449_68769)">
            <circle cx="692.4" cy="68.8302" r="19.2921" transform="rotate(-60 692.4 68.8302)" fill="#FFC8FE" />
          </g>
        </g>
        <path
          d="M649.734 104.85C652.071 110.233 656.991 114.838 659.159 116.468C667.588 120.641 684.575 129.05 685.089 129.296C685.602 129.542 686.197 129.158 686.431 128.936L689.872 123.739L688.353 121.35L667.405 106.987L666.768 98.0487L658.356 93.1915L650.194 86.589L646.665 91.6096C646.714 93.7805 647.397 99.4679 649.734 104.85Z"
          fill="url(#paint11_linear_6449_68769)"
        />
        <mask
          id="mask3_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="646"
          y="86"
          width="44"
          height="44"
        >
          <path
            d="M649.733 104.85C652.07 110.233 656.991 114.838 659.158 116.468C667.588 120.641 684.575 129.05 685.088 129.296C685.602 129.542 686.197 129.158 686.43 128.936L689.872 123.739L688.353 121.35L667.405 106.987L666.768 98.0487L658.355 93.1915L650.194 86.589L646.665 91.6096C646.714 93.7805 647.396 99.4679 649.733 104.85Z"
            fill="url(#paint12_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask3_6449_68769)">
          <g opacity="0.64" filter="url(#filter6_f_6449_68769)">
            <circle cx="668.424" cy="86.5597" r="18.1461" transform="rotate(-60 668.424 86.5597)" fill="#FFC8FE" />
          </g>
        </g>
        <path
          d="M685.67 129.592C685.461 129.826 685.29 129.976 685.167 130.034L685.67 129.592C686.55 128.613 688.12 126.157 689.762 122.73C691.238 119.65 690.293 120.537 690.445 119.911L708.525 107.915C703.274 113.517 698.932 118.635 690.277 125.549L685.67 129.592Z"
          fill="url(#paint13_linear_6449_68769)"
        />
        <path
          d="M663.225 105.391L664.16 99.188C664.16 99.188 665.783 99.4322 667.262 99.4354C668.741 99.4386 670.6 99.2201 670.6 99.2201C670.49 99.7025 670.206 100.952 669.951 102.091C669.573 103.511 670.494 104.043 671.298 104.507C674.55 106.951 685.698 113.073 688.218 114.275C690.738 115.478 690.829 114.774 691.432 114.493C692.036 114.211 704.182 106.163 710.875 94.4613C717.567 82.76 715.873 77.1814 715.41 74.7086C714.947 72.2358 714.807 71.7139 709.282 67.6413C704.861 64.3832 699.717 62.4135 697.698 61.8359C698.278 59.3474 697.417 57.5565 696.914 56.9721C699.342 57.9198 708.343 63.0454 712.54 65.4897C713.824 66.504 716.663 68.7397 717.748 69.5676C719.087 70.5893 719.123 70.6751 719.949 72.6084L719.982 72.6846C720.839 74.6921 721.815 80.4232 720.905 85.821C719.994 91.2188 716.726 100.045 707.534 108.98C700.18 116.128 692.314 121.661 689.3 123.534C685.992 121.624 666.669 110.341 664.807 108.763C663.318 107.5 663.132 105.989 663.225 105.391Z"
          fill="url(#paint14_linear_6449_68769)"
        />
        <mask
          id="mask4_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="663"
          y="56"
          width="59"
          height="68"
        >
          <path
            d="M663.226 105.391L664.161 99.188C664.161 99.188 665.784 99.4322 667.263 99.4354C668.742 99.4386 670.601 99.2201 670.601 99.2201C670.491 99.7025 670.206 100.952 669.952 102.091C669.574 103.511 670.495 104.043 671.299 104.507C674.551 106.951 685.699 113.073 688.219 114.275C690.738 115.478 690.83 114.774 691.433 114.493C692.037 114.211 704.183 106.163 710.876 94.4613C717.568 82.76 715.874 77.1814 715.411 74.7086C714.948 72.2358 714.808 71.7139 709.283 67.6413C704.862 64.3832 699.718 62.4135 697.699 61.8359C698.279 59.3474 697.418 57.5565 696.915 56.9721C699.343 57.9198 708.344 63.0454 712.541 65.4897C713.825 66.504 716.664 68.7397 717.749 69.5676C719.088 70.5893 719.124 70.6751 719.95 72.6084L719.982 72.6846C720.84 74.6921 721.816 80.4232 720.906 85.821C719.995 91.2188 716.727 100.045 707.535 108.98C700.181 116.128 692.315 121.661 689.301 123.534C685.993 121.624 666.67 110.341 664.808 108.763C663.319 107.5 663.133 105.989 663.226 105.391Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask4_6449_68769)">
          <path
            d="M668.83 102.891L669.741 99.1316L696.657 60.6973L697.901 60.3441C699.678 61.0865 703.711 62.9423 707.235 64.9143C710.76 66.8863 713.845 69.4554 715.191 70.4531C716.538 71.4507 717.122 75.569 717.259 76.7509C717.395 77.9327 717.796 83.0791 714.683 89.7261C711.57 96.3732 707.032 102.103 701.346 107.422C695.66 112.741 692.616 114.576 691.639 115.177C690.661 115.779 690.352 116.041 688.998 115.386C687.643 114.73 684.647 113.315 680.816 111.166C676.984 109.016 671.374 105.526 670.716 105.083C670.058 104.64 669.477 104.336 669.063 103.908C668.731 103.565 668.77 103.087 668.83 102.891Z"
            fill="url(#paint15_linear_6449_68769)"
          />
        </g>
        <mask
          id="mask5_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="668"
          y="56"
          width="54"
          height="60"
        >
          <mask
            id="mask6_6449_68769"
            style={{maskType: 'alpha'}}
            maskUnits="userSpaceOnUse"
            x="663"
            y="56"
            width="59"
            height="68"
          >
            <path
              d="M663.227 105.391L664.162 99.188C664.162 99.188 665.786 99.4322 667.265 99.4354C668.744 99.4386 670.603 99.2201 670.603 99.2201C670.492 99.7025 670.208 100.952 669.954 102.091C669.575 103.511 670.497 104.043 671.3 104.507C674.552 106.951 685.701 113.073 688.22 114.275C690.74 115.478 690.831 114.774 691.435 114.493C692.039 114.211 704.184 106.163 710.877 94.4613C717.57 82.76 715.875 77.1814 715.412 74.7086C714.95 72.2358 714.81 71.7139 709.284 67.6413C704.863 64.3832 699.72 62.4135 697.701 61.8359C698.28 59.3474 697.42 57.5565 696.917 56.9721C699.344 57.9198 708.345 63.0454 712.543 65.4897C713.827 66.504 716.666 68.7397 717.75 69.5676C719.089 70.5893 719.126 70.6751 719.951 72.6084L719.984 72.6846C720.841 74.6921 721.818 80.4232 720.907 85.821C719.996 91.2188 716.728 100.045 707.536 108.98C700.183 116.128 692.317 121.661 689.303 123.534C685.994 121.624 666.671 110.341 664.81 108.763C663.321 107.5 663.134 105.989 663.227 105.391Z"
              fill="#D9D9D9"
            />
          </mask>
          <g mask="url(#mask6_6449_68769)">
            <path
              d="M668.832 102.891L669.742 99.1316L696.658 60.6973L697.902 60.3441C699.679 61.0865 703.712 62.9423 707.237 64.9143C710.761 66.8863 713.847 69.4554 715.193 70.4531C716.539 71.4507 717.123 75.569 717.26 76.7509C717.397 77.9327 717.797 83.0791 714.684 89.7261C711.571 96.3732 707.034 102.103 701.348 107.422C695.662 112.741 692.617 114.576 691.64 115.177C690.663 115.779 690.353 116.041 688.999 115.386C687.645 114.73 684.649 113.315 680.817 111.166C676.985 109.016 671.375 105.526 670.717 105.083C670.059 104.64 669.478 104.336 669.064 103.908C668.733 103.565 668.771 103.087 668.832 102.891Z"
              fill="url(#paint16_linear_6449_68769)"
            />
            <ellipse
              cx="723.214"
              cy="63.7112"
              rx="22.9213"
              ry="21.5843"
              transform="rotate(-60 723.214 63.7112)"
              fill="#9EECFF"
            />
          </g>
        </mask>
        <g mask="url(#mask5_6449_68769)">
          <g opacity="0.71" filter="url(#filter7_f_6449_68769)">
            <ellipse
              cx="699.7"
              cy="90.2452"
              rx="24.695"
              ry="23.2488"
              transform="rotate(-60 699.7 90.2452)"
              fill="#F8FFEB"
            />
          </g>
        </g>
        <path
          d="M645.838 90.3127C645.701 95.1288 646.868 96.6311 647.418 97.2428C646.268 93.1762 648.608 89.3597 650.402 88.253L650.454 87.4003C651.194 80.7698 653.72 74.6974 656.41 71.0202C658.562 68.0784 662.547 67.0852 664.233 66.9664C662.485 64.1426 662.223 62.298 662.293 61.8132C648.979 70.5742 646.029 83.6169 645.838 90.3127Z"
          fill="url(#paint17_linear_6449_68769)"
        />
        <mask
          id="mask7_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="645"
          y="61"
          width="20"
          height="37"
        >
          <path
            d="M645.837 90.3127C645.7 95.1288 646.867 96.6311 647.417 97.2428C646.267 93.1762 648.607 89.3597 650.401 88.253L650.453 87.4003C651.193 80.7698 653.719 74.6974 656.409 71.0202C658.561 68.0784 662.546 67.0852 664.232 66.9664C662.484 64.1426 662.222 62.298 662.292 61.8132C648.978 70.5742 646.028 83.6169 645.837 90.3127Z"
            fill="url(#paint18_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask7_6449_68769)">
          <g opacity="0.75" filter="url(#filter8_f_6449_68769)">
            <circle cx="674.401" cy="73.9717" r="27.9422" transform="rotate(-60 674.401 73.9717)" fill="#FFC8FE" />
          </g>
        </g>
        <mask
          id="mask8_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="645"
          y="61"
          width="20"
          height="37"
        >
          <path
            d="M646.029 89.982C645.611 94.7817 646.844 96.6175 647.394 97.2292C646.298 93.288 648.66 89.5788 650.416 88.2294L650.42 87.3494C651.16 80.7189 653.72 74.6975 656.41 71.0202C658.562 68.0784 662.547 67.0853 664.233 66.9664C662.485 64.1427 662.223 62.298 662.293 61.8132C648.979 70.5742 646.547 84.0422 646.029 89.982Z"
            fill="url(#paint19_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask8_6449_68769)">
          <path
            d="M647.091 90.8784C645.51 93.6175 646.522 96.4421 647.451 97.6714L651.376 88.9092L651.313 86.7307C650.681 86.9536 648.592 88.2789 647.091 90.8784Z"
            fill="url(#paint20_linear_6449_68769)"
          />
        </g>
        <path
          d="M658.62 118.171C658.432 120.331 661.222 125.744 662.569 128.14L672.564 133.532C678.838 133.689 684.494 129.896 685.167 129.276C685.84 128.656 686.545 128.307 685.388 125.182C684.231 122.056 677.987 118.136 673.969 115.816C669.952 113.497 666.349 112.425 662.938 112.22C660.209 112.056 659.337 113.292 659.241 113.93C659.113 114.444 658.808 116.012 658.62 118.171Z"
          fill="url(#paint21_linear_6449_68769)"
        />
        <mask
          id="mask9_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="658"
          y="112"
          width="29"
          height="22"
        >
          <path
            d="M658.618 118.171C658.43 120.331 661.22 125.744 662.567 128.14L672.562 133.532C678.836 133.689 684.492 129.896 685.165 129.276C685.838 128.656 686.543 128.307 685.386 125.182C684.229 122.056 677.985 118.136 673.967 115.816C669.95 113.497 666.347 112.425 662.936 112.22C660.208 112.056 659.335 113.292 659.239 113.93C659.111 114.444 658.806 116.012 658.618 118.171Z"
            fill="url(#paint22_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask9_6449_68769)">
          <g opacity="0.74" filter="url(#filter9_f_6449_68769)">
            <ellipse
              cx="646.18"
              cy="118.488"
              rx="31.4895"
              ry="28.5152"
              transform="rotate(-60 646.18 118.488)"
              fill="#C06EFF"
            />
          </g>
          <g opacity="0.74" filter="url(#filter10_f_6449_68769)">
            <ellipse
              cx="644.54"
              cy="135.567"
              rx="23.6308"
              ry="21.3932"
              transform="rotate(-60 644.54 135.567)"
              fill="#FFC8FE"
            />
          </g>
          <g opacity="0.74" filter="url(#filter11_f_6449_68769)">
            <ellipse
              cx="687.875"
              cy="132.039"
              rx="20.5201"
              ry="9.19582"
              transform="rotate(-30.1448 687.875 132.039)"
              fill="#9EECFF"
            />
          </g>
          <g filter="url(#filter12_f_6449_68769)">
            <ellipse
              cx="685.206"
              cy="127.532"
              rx="5.39489"
              ry="1.54579"
              transform="rotate(-33.3272 685.206 127.532)"
              fill="#9EECFF"
            />
          </g>
        </g>
        <g filter="url(#filter13_i_6449_68769)">
          <ellipse
            cx="668.414"
            cy="129.309"
            rx="3.11075"
            ry="7.34028"
            transform="rotate(-60 668.414 129.309)"
            fill="url(#paint23_linear_6449_68769)"
          />
        </g>
        <path
          d="M656.99 84.2101L658.097 91.0249L664.903 94.9542C666.509 95.0832 669.859 95.3202 670.412 95.236C671.103 95.1308 675.5 92.754 675.773 92.2814L679.593 85.6646C679.899 85.1352 680.936 82.0287 681.416 80.5416L677.785 75.0424L670.692 71.8293L664.118 70.5545L659.317 75.5965L656.99 84.2101Z"
          fill="url(#paint24_linear_6449_68769)"
        />
        <path
          d="M656.99 84.2101L658.097 91.0249L664.903 94.9542C666.509 95.0832 669.859 95.3202 670.412 95.236C671.103 95.1308 675.5 92.754 675.773 92.2814L679.593 85.6646C679.899 85.1352 680.936 82.0287 681.416 80.5416L677.785 75.0424L670.692 71.8293L664.118 70.5545L659.317 75.5965L656.99 84.2101Z"
          fill="url(#paint25_linear_6449_68769)"
        />
        <path
          d="M669.017 64.6871L668.178 61.556L669.815 58.7202C670.142 58.153 672.874 55.823 674.311 55.5181C675.747 55.2131 678.013 54.1265 678.485 54.3994C678.958 54.6723 683.547 54.801 684.238 54.6958C684.929 54.5906 688.932 55.5155 689.688 55.9521L693.942 58.4079C694.604 58.7899 694.315 62.7825 693.988 63.3497C693.726 63.8034 691.393 66.3888 690.259 67.6247L684.997 69.7539C682.445 69.0792 677.248 67.6751 676.87 67.4568C676.492 67.2385 671.477 65.5194 669.017 64.6871Z"
          fill="#D9D9D9"
        />
        <path
          d="M689.123 73.5224C686.603 75.0925 684.36 74.9318 683.553 74.6552L664.641 68.3365C664.683 68.1923 664.565 67.574 663.764 66.2545C662.763 64.6051 660.783 62.1391 664.003 58.2002C667.222 54.2613 669.944 52.4931 673.958 51.2181C678.393 49.8088 684.892 50.7252 688.353 51.7154C691.815 52.7056 696.033 54.8957 697.135 57.3526C698.127 59.5638 698.216 60.9384 696.342 65.2758C694.468 69.6133 692.272 71.5599 689.123 73.5224Z"
          fill="url(#paint26_linear_6449_68769)"
        />
        <path
          d="M689.123 73.5224C686.603 75.0925 684.36 74.9318 683.553 74.6552L664.641 68.3365C664.683 68.1923 664.565 67.574 663.764 66.2545C662.763 64.6051 660.783 62.1391 664.003 58.2002C667.222 54.2613 669.944 52.4931 673.958 51.2181C678.393 49.8088 684.892 50.7252 688.353 51.7154C691.815 52.7056 696.033 54.8957 697.135 57.3526C698.127 59.5638 698.216 60.9384 696.342 65.2758C694.468 69.6133 692.272 71.5599 689.123 73.5224Z"
          fill="url(#paint27_linear_6449_68769)"
        />
        <path
          d="M663.764 66.2546C662.763 64.6052 660.784 62.1389 664.003 58.2002C667.222 54.2613 669.944 52.4928 673.957 51.2177C678.393 49.8085 684.892 50.7245 688.353 51.7147C691.815 52.7049 696.033 54.8952 697.135 57.352C698.127 59.5632 698.216 60.938 696.341 65.2755C694.467 69.6129 692.272 71.5591 689.122 73.5217C686.603 75.0917 684.36 74.931 683.553 74.6544L664.641 68.3364C664.682 68.1922 664.565 67.5738 663.764 66.2546ZM671.223 59.5012C670.054 61.0448 669.887 62.3432 669.949 62.7993C670.615 63.3406 675.17 64.8359 677.062 65.4873C678.954 66.1388 681.145 67.3099 683.94 67.5999C686.734 67.8898 688.839 65.8274 688.941 65.7602C689.052 65.684 692.508 62.5245 692.137 60.7687C691.766 59.0105 690.25 57.9784 686.766 56.7546C683.282 55.5308 680.763 55.1473 677.888 55.3782C675.014 55.6091 672.683 57.5717 671.223 59.5012Z"
          fill="url(#paint28_linear_6449_68769)"
        />
        <mask
          id="mask10_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="662"
          y="50"
          width="36"
          height="25"
        >
          <path
            d="M663.767 66.2541C662.766 64.6047 660.787 62.1386 664.006 58.1997C667.225 54.2608 669.948 52.4923 673.961 51.2172C678.396 49.8081 684.895 50.7249 688.356 51.7151C691.818 52.7053 696.036 54.8955 697.138 57.3524C698.13 59.5633 698.219 60.9379 696.345 65.275C694.471 69.6124 692.275 71.5587 689.126 73.5212C686.606 75.0913 684.363 74.9305 683.556 74.6539L664.645 68.3359C664.686 68.1917 664.568 67.5733 663.767 66.2541ZM671.227 59.5012C670.059 61.0448 669.89 62.3427 669.952 62.7988C670.617 63.3399 675.174 64.8358 677.066 65.4873C678.958 66.1388 681.15 67.3099 683.944 67.5999C686.738 67.8898 688.842 65.8269 688.944 65.7597C689.046 65.6919 692.512 62.5269 692.141 60.7687C691.77 59.0105 690.255 57.9776 686.771 56.7538C683.287 55.5299 680.767 55.1473 677.892 55.3782C675.018 55.6091 672.688 57.5717 671.227 59.5012Z"
            fill="url(#paint29_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask10_6449_68769)">
          <g filter="url(#filter14_f_6449_68769)">
            <ellipse
              cx="672.049"
              cy="72.6439"
              rx="15.8539"
              ry="14.3531"
              transform="rotate(-60 672.049 72.6439)"
              fill="#0527FC"
            />
          </g>
          <g filter="url(#filter15_f_6449_68769)">
            <ellipse
              cx="699.42"
              cy="63.933"
              rx="15.8539"
              ry="14.3531"
              transform="rotate(-60 699.42 63.933)"
              fill="#9EECFF"
            />
          </g>
        </g>
        <mask
          id="mask11_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="662"
          y="50"
          width="36"
          height="25"
        >
          <path
            d="M663.767 66.2541C662.766 64.6047 660.787 62.1386 664.006 58.1997C667.225 54.2608 669.948 52.4923 673.961 51.2172C678.396 49.8081 684.895 50.7249 688.356 51.7151C691.818 52.7053 696.036 54.8955 697.138 57.3524C698.13 59.5633 698.219 60.9379 696.345 65.275C694.471 69.6124 692.275 71.5587 689.126 73.5212C686.606 75.0913 684.363 74.9305 683.556 74.6539L664.645 68.3359C664.686 68.1917 664.568 67.5733 663.767 66.2541ZM671.227 59.5012C670.059 61.0448 669.89 62.3427 669.952 62.7988C670.617 63.3399 675.174 64.8358 677.066 65.4873C678.958 66.1388 681.15 67.3099 683.944 67.5999C686.738 67.8898 688.842 65.8269 688.944 65.7597C689.046 65.6919 692.512 62.5269 692.141 60.7687C691.77 59.0105 690.255 57.9776 686.771 56.7538C683.287 55.5299 680.767 55.1473 677.892 55.3782C675.018 55.6091 672.688 57.5717 671.227 59.5012Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask11_6449_68769)">
          <path
            d="M662.868 64.5367C663.661 65.5636 667.686 66.5609 670.267 67.548C673.501 68.7854 679.888 71.1625 682.723 71.8412C686.266 72.6896 689.066 72.2727 693.184 68.2391C696.665 64.8294 698.274 61.2421 698.31 60.2337L699.59 60.0904C698.473 58.0592 696.179 53.9491 695.936 53.7584C695.632 53.5202 687.154 49.7593 686.234 49.6063C685.314 49.4533 673.758 48.0751 673.209 48.2622C672.77 48.4119 665.436 55.2856 661.824 58.7038C661.708 59.9601 661.742 63.0804 662.868 64.5367Z"
            fill="url(#paint30_linear_6449_68769)"
          />
        </g>
        <mask
          id="mask12_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="662"
          y="50"
          width="36"
          height="23"
        >
          <mask
            id="mask13_6449_68769"
            style={{maskType: 'alpha'}}
            maskUnits="userSpaceOnUse"
            x="662"
            y="50"
            width="36"
            height="25"
          >
            <path
              d="M663.761 66.2542C662.76 64.6048 660.781 62.1386 664 58.1998C667.219 54.2613 669.942 52.4932 673.955 51.2182C678.39 49.809 684.889 50.7251 688.351 51.7152C691.812 52.7054 696.03 54.8957 697.132 57.3525C698.124 59.5637 698.213 60.9385 696.339 65.276C694.465 69.6133 692.27 71.5601 689.12 73.5227C686.601 75.0926 684.358 74.932 683.551 74.6554L664.638 68.3369C664.68 68.1927 664.562 67.5737 663.761 66.2542ZM671.221 59.5013C670.053 61.0449 669.885 62.3433 669.947 62.7994C670.612 63.3406 675.167 64.8368 677.06 65.4883C678.952 66.1398 681.144 67.31 683.938 67.6C686.731 67.8899 688.835 65.8301 688.939 65.7611C689.04 65.6939 692.507 62.5271 692.135 60.7689C691.764 59.0109 690.249 57.9785 686.765 56.7547C683.281 55.531 680.761 55.1474 677.887 55.3783C675.012 55.6092 672.682 57.5719 671.221 59.5013Z"
              fill="#D9D9D9"
            />
          </mask>
          <g mask="url(#mask13_6449_68769)">
            <path
              d="M662.865 64.5382C663.658 65.5651 667.683 66.5624 670.264 67.5495C673.498 68.7869 679.886 71.1639 682.72 71.8426C686.263 72.691 689.063 72.2741 693.181 68.2406C696.662 64.8309 698.271 61.2436 698.307 60.2351L699.587 60.0919C698.47 58.0606 696.176 53.9505 695.933 53.7599C695.629 53.5216 687.151 49.7608 686.231 49.6078C685.311 49.4548 673.755 48.0766 673.206 48.2636C672.767 48.4133 665.433 55.2871 661.821 58.7052C661.705 59.9615 661.739 63.0819 662.865 64.5382Z"
              fill="url(#paint31_linear_6449_68769)"
            />
          </g>
        </mask>
        <g mask="url(#mask12_6449_68769)">
          <g opacity="0.71" filter="url(#filter16_f_6449_68769)">
            <path
              d="M691.885 49.2508C690.413 49.8663 687.949 54.3282 685.956 57.079C683.457 60.5266 678.603 67.3551 676.895 70.5054C674.76 74.4432 674.365 77.9009 677.846 84.0757C680.788 89.2954 684.537 92.3484 685.723 92.7124L685.486 94.2782C688.254 93.5985 693.866 92.1822 694.169 91.9545C694.549 91.6698 701.712 82.7981 702.186 81.7543C702.661 80.7105 707.973 67.4258 707.925 66.7141C707.887 66.1447 702.056 55.2466 699.145 49.8687C697.69 49.3308 693.973 48.3781 691.885 49.2508Z"
              fill="url(#paint32_linear_6449_68769)"
            />
          </g>
        </g>
        <mask
          id="mask14_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="662"
          y="50"
          width="36"
          height="23"
        >
          <mask
            id="mask15_6449_68769"
            style={{maskType: 'alpha'}}
            maskUnits="userSpaceOnUse"
            x="662"
            y="50"
            width="36"
            height="25"
          >
            <path
              d="M663.761 66.2542C662.76 64.6048 660.781 62.1386 664 58.1998C667.219 54.2613 669.942 52.4932 673.955 51.2182C678.39 49.809 684.889 50.7251 688.351 51.7152C691.812 52.7054 696.03 54.8957 697.132 57.3525C698.124 59.5637 698.213 60.9385 696.339 65.276C694.465 69.6133 692.27 71.5601 689.12 73.5227C686.601 75.0926 684.358 74.932 683.551 74.6554L664.638 68.3369C664.68 68.1927 664.562 67.5737 663.761 66.2542ZM671.221 59.5013C670.053 61.0449 669.885 62.3433 669.947 62.7994C670.613 63.3408 675.168 64.836 677.06 65.4874C678.953 66.139 681.144 67.3101 683.938 67.6C686.732 67.89 688.837 65.8275 688.939 65.7603C689.048 65.6863 692.506 62.5252 692.135 60.7689C691.764 59.0106 690.249 57.9786 686.765 56.7547C683.281 55.531 680.761 55.1474 677.887 55.3783C675.012 55.6092 672.682 57.5718 671.221 59.5013Z"
              fill="#D9D9D9"
            />
          </mask>
          <g mask="url(#mask15_6449_68769)">
            <path
              d="M662.865 64.5377C663.658 65.5646 667.683 66.5619 670.264 67.549C673.498 68.7864 679.886 71.1634 682.72 71.8422C686.263 72.6905 689.063 72.2737 693.181 68.2401C696.662 64.8304 698.271 61.2431 698.307 60.2346L699.587 60.0914C698.47 58.0601 696.176 53.95 695.933 53.7594C695.629 53.5211 687.151 49.7603 686.231 49.6073C685.311 49.4543 673.755 48.0761 673.206 48.2632C672.767 48.4128 665.433 55.2866 661.821 58.7047C661.705 59.961 661.739 63.0814 662.865 64.5377Z"
              fill="url(#paint33_linear_6449_68769)"
            />
          </g>
        </mask>
        <g mask="url(#mask14_6449_68769)">
          <mask
            id="mask16_6449_68769"
            style={{maskType: 'alpha'}}
            maskUnits="userSpaceOnUse"
            x="667"
            y="51"
            width="27"
            height="17"
          >
            <path
              d="M668.201 61.4016C668.574 62.3604 669.625 62.7557 671.455 63.4062C676.37 65.1533 683.879 67.7492 685.16 67.3926C688.989 66.3265 693.214 61.538 693.07 58.2408C692.926 54.9435 686.456 52.9415 685.188 52.682C683.92 52.4225 678.204 50.0989 673.544 53.8046C668.883 57.5103 667.34 59.1834 668.201 61.4016Z"
              fill="url(#paint34_linear_6449_68769)"
            />
          </mask>
          <g mask="url(#mask16_6449_68769)">
            <g filter="url(#filter17_f_6449_68769)">
              <ellipse
                cx="678.378"
                cy="53.8293"
                rx="7.81214"
                ry="11.7519"
                transform="rotate(-120 678.378 53.8293)"
                fill="#0527FC"
              />
            </g>
            <g filter="url(#filter18_f_6449_68769)">
              <ellipse
                cx="695.297"
                cy="62.019"
                rx="3.62547"
                ry="7.9119"
                transform="rotate(-170.803 695.297 62.019)"
                fill="#9EECFF"
              />
            </g>
            <g filter="url(#filter19_f_6449_68769)">
              <ellipse
                cx="674.49"
                cy="53.839"
                rx="6.21064"
                ry="8.83429"
                transform="rotate(-120 674.49 53.839)"
                fill="#001386"
              />
            </g>
          </g>
        </g>
        <path
          d="M650.847 84.2558C651.681 79.318 655.054 71.1835 658.638 68.9046C662.223 66.6258 665.418 66.7685 668.563 67.3241C671.708 67.8797 679.621 70.8734 682.475 73.0252C685.328 75.1769 685.599 78.4204 685.068 81.9583C684.538 85.4962 682.14 93.6896 674.526 97.9272C672.067 99.2958 666.966 100.432 659.611 98.3278C657.731 97.8726 653.597 96.4309 652.101 94.307C650.232 91.652 650.012 89.1933 650.847 84.2558ZM667.739 73.3382C662.001 72.1995 659.502 79.2017 658.71 81.6113C657.917 84.0211 657.746 89.1204 659.011 90.0398C660.023 90.7753 661.834 91.6074 662.614 91.9313C663.57 92.2944 665.845 93.0587 667.292 93.2141C669.102 93.4083 671.36 94.0818 674.249 91.3701C677.138 88.6585 679.55 82.8995 679.794 80.6766C679.988 78.8985 678.863 77.6492 678.276 77.2472C676.873 75.965 671.843 74.1527 667.739 73.3382Z"
          fill="url(#paint35_linear_6449_68769)"
        />
        <mask
          id="mask17_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="650"
          y="66"
          width="36"
          height="34"
        >
          <path
            d="M650.849 84.2563C651.684 79.3186 655.057 71.1841 658.641 68.9051C662.226 66.6263 665.421 66.769 668.566 67.3245C671.711 67.8802 679.624 70.8731 682.478 73.0248C685.332 75.1766 685.602 78.4209 685.071 81.9588C684.541 85.497 682.142 93.6898 674.528 97.9272C672.069 99.2958 666.969 100.432 659.614 98.3283C657.734 97.8731 653.6 96.4314 652.104 94.3074C650.234 91.6524 650.015 89.194 650.849 84.2563ZM667.742 73.3387C662.004 72.1998 659.506 79.201 658.713 81.6109C657.92 84.0204 657.749 89.1197 659.013 90.0398C660.025 90.7754 661.838 91.6071 662.617 91.9309C663.573 92.294 665.848 93.0592 667.295 93.2145C669.105 93.4088 671.363 94.0821 674.252 91.3706C677.141 88.6588 679.553 82.8983 679.796 80.6757C679.991 78.8982 678.866 77.6499 678.279 77.2477C676.876 75.9655 671.846 74.1532 667.742 73.3387Z"
            fill="url(#paint36_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask17_6449_68769)">
          <g opacity="0.6" filter="url(#filter20_f_6449_68769)">
            <ellipse
              cx="683.585"
              cy="88.2524"
              rx="17.0546"
              ry="18.2006"
              transform="rotate(30 683.585 88.2524)"
              fill="#0527FC"
            />
          </g>
          <g opacity="0.6" filter="url(#filter21_f_6449_68769)">
            <ellipse
              cx="684.237"
              cy="86.5191"
              rx="9.76886"
              ry="10.4237"
              transform="rotate(30 684.237 86.5191)"
              fill="#8342FA"
            />
          </g>
        </g>
        <mask
          id="mask18_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="650"
          y="66"
          width="36"
          height="34"
        >
          <path
            d="M650.849 84.2563C651.684 79.3186 655.057 71.1841 658.641 68.9051C662.226 66.6263 665.421 66.769 668.566 67.3245C671.711 67.8802 679.624 70.8731 682.478 73.0248C685.332 75.1766 685.602 78.4209 685.071 81.9588C684.541 85.497 682.142 93.6898 674.528 97.9272C672.069 99.2958 666.969 100.432 659.614 98.3283C657.734 97.8731 653.6 96.4314 652.104 94.3074C650.234 91.6524 650.015 89.194 650.849 84.2563ZM667.742 73.3387C662.004 72.1998 659.506 79.201 658.713 81.6109C657.92 84.0204 657.749 89.1197 659.013 90.0398C660.025 90.7754 661.838 91.6071 662.617 91.9309C663.573 92.294 665.848 93.0592 667.295 93.2145C669.105 93.4088 671.363 94.0821 674.252 91.3706C677.141 88.6588 679.553 82.8983 679.796 80.6757C679.991 78.8982 678.866 77.6499 678.279 77.2477C676.876 75.9655 671.846 74.1532 667.742 73.3387Z"
            fill="url(#paint37_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask18_6449_68769)">
          <path
            d="M669.754 93.9735C673.687 93.6228 676.388 89.9054 677.247 88.0906C678.011 86.7672 679.485 84.213 679.872 82.2333C680.613 78.4391 680.603 76.1646 674.475 73.5718C669.572 71.4975 665.964 71.0315 664.772 71.0578C659.54 71.0616 656.535 79.9768 655.886 84.2656C655.238 88.5544 655.53 89.7945 657.61 90.9951C660.945 92.858 664.838 94.4119 669.754 93.9735Z"
            fill="url(#paint38_linear_6449_68769)"
          />
        </g>
        <mask
          id="mask19_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="650"
          y="66"
          width="36"
          height="34"
        >
          <path
            d="M650.849 84.2563C651.684 79.3186 655.057 71.1841 658.641 68.9051C662.226 66.6263 665.421 66.769 668.566 67.3245C671.711 67.8802 679.624 70.8731 682.478 73.0248C685.332 75.1766 685.602 78.4209 685.071 81.9588C684.541 85.497 682.142 93.6898 674.528 97.9272C672.069 99.2958 666.969 100.432 659.614 98.3283C657.734 97.8731 653.6 96.4314 652.104 94.3074C650.234 91.6524 650.015 89.194 650.849 84.2563ZM667.742 73.3387C662.004 72.1998 659.506 79.201 658.713 81.6109C657.92 84.0204 657.749 89.1197 659.013 90.0398C660.025 90.7754 661.838 91.6071 662.617 91.9309C663.573 92.294 665.848 93.0592 667.295 93.2145C669.105 93.4088 671.363 94.0821 674.252 91.3706C677.141 88.6588 679.553 82.8983 679.796 80.6757C679.991 78.8982 678.866 77.6499 678.279 77.2477C676.876 75.9655 671.846 74.1532 667.742 73.3387Z"
            fill="url(#paint39_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask19_6449_68769)">
          <path
            d="M665.29 98.6447C658.125 98.7428 653.669 96.1787 652.337 94.8843C654.519 97.5092 658.97 102.759 659.322 102.761C659.762 102.763 671.105 103.199 671.485 102.978C671.789 102.8 676.597 100.236 678.963 98.9764L688.841 81.8672L685.291 71.7517L682.597 70.1963C683.32 72.0001 688.101 78.0482 683.033 87.7778C678.971 95.5782 674.246 98.5222 665.29 98.6447Z"
            fill="url(#paint40_linear_6449_68769)"
          />
        </g>
        <mask
          id="mask20_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="655"
          y="71"
          width="26"
          height="24"
        >
          <mask
            id="mask21_6449_68769"
            style={{maskType: 'alpha'}}
            maskUnits="userSpaceOnUse"
            x="650"
            y="66"
            width="36"
            height="34"
          >
            <path
              d="M650.849 84.2553C651.684 79.3175 655.057 71.182 658.642 68.9032C662.226 66.6246 665.421 66.768 668.566 67.3236C671.711 67.8792 679.624 70.8721 682.478 73.0238C685.332 75.1756 685.602 78.4199 685.071 81.9578C684.541 85.496 682.142 93.6889 674.528 97.9262C672.069 99.2948 666.969 100.431 659.614 98.3273C657.734 97.8721 653.6 96.4304 652.104 94.3065C650.234 91.6515 650.015 89.1929 650.849 84.2553ZM667.742 73.3377C662.004 72.1991 659.506 79.2003 658.713 81.61C657.92 84.0197 657.749 89.1199 659.014 90.0393C660.026 90.7749 661.838 91.6061 662.617 91.93C663.573 92.293 665.847 93.0581 667.295 93.2136C669.105 93.4078 671.363 94.0805 674.252 91.3687C677.141 88.6569 679.553 82.8973 679.796 80.6747C679.991 78.8969 678.866 77.6488 678.279 77.2467C676.876 75.9645 671.846 74.1523 667.742 73.3377Z"
              fill="url(#paint41_linear_6449_68769)"
            />
          </mask>
          <g mask="url(#mask21_6449_68769)">
            <path
              d="M669.752 93.9725C673.686 93.6218 676.386 89.9044 677.245 88.0896C678.009 86.7662 679.484 84.212 679.871 82.2323C680.612 78.4381 680.602 76.1636 674.473 73.5708C669.571 71.4965 665.962 71.0306 664.771 71.0568C659.538 71.0606 656.534 79.9758 655.885 84.2646C655.236 88.5534 655.529 89.7935 657.608 90.9941C660.944 92.857 664.836 94.4109 669.752 93.9725Z"
              fill="url(#paint42_linear_6449_68769)"
            />
          </g>
        </mask>
        <g mask="url(#mask20_6449_68769)">
          <g filter="url(#filter22_f_6449_68769)">
            <ellipse
              cx="660.881"
              cy="80.181"
              rx="9.52445"
              ry="14.3277"
              transform="rotate(-120 660.881 80.181)"
              fill="#0527FC"
            />
          </g>
          <g filter="url(#filter23_f_6449_68769)">
            <ellipse
              cx="682.666"
              cy="77.5252"
              rx="4.42012"
              ry="6.64923"
              transform="rotate(-170.803 682.666 77.5252)"
              fill="#9EECFF"
            />
          </g>
          <g filter="url(#filter24_f_6449_68769)">
            <ellipse
              cx="656.146"
              cy="80.192"
              rx="7.57193"
              ry="10.7707"
              transform="rotate(-120 656.146 80.192)"
              fill="#001386"
            />
          </g>
          <g opacity="0.81" filter="url(#filter25_f_6449_68769)">
            <ellipse
              cx="677.381"
              cy="78.0636"
              rx="4.42012"
              ry="6.64924"
              transform="rotate(-128.062 677.381 78.0636)"
              fill="#9EECFF"
            />
          </g>
        </g>
        <path
          d="M693.366 89.1365C692.263 89.5147 691.245 90.82 690.991 92.182C690.736 93.544 691.203 95.5122 692.925 97.1136C692.881 96.8119 692.33 92.7421 694.45 91.0586C696.57 89.3752 697.627 89.6072 697.627 89.6072C695.864 88.5552 694.468 88.7584 693.366 89.1365Z"
          fill="url(#paint43_linear_6449_68769)"
        />
        <path
          d="M702.09 81.1932L702.985 81.8697C702.985 81.8697 702.192 79.8199 702.95 77.8815C703.708 75.9432 706.043 75.5033 706.817 75.4075C706.817 75.4075 704.898 74.3951 703.178 74.8296C701.457 75.2641 700.752 76.4902 700.639 78.0162C700.502 79.8475 702.09 81.1932 702.09 81.1932Z"
          fill="url(#paint44_linear_6449_68769)"
        />
        <g filter="url(#filter26_f_6449_68769)">
          <path
            d="M693.366 89.1365C692.263 89.5147 691.245 90.82 690.991 92.182C690.736 93.544 691.203 95.5122 692.925 97.1136C692.881 96.8119 692.33 92.7421 694.45 91.0586C696.57 89.3752 697.627 89.6072 697.627 89.6072C695.864 88.5552 694.468 88.7584 693.366 89.1365Z"
            fill="url(#paint45_linear_6449_68769)"
          />
          <path
            d="M693.366 89.1365C692.263 89.5147 691.245 90.82 690.991 92.182C690.736 93.544 691.203 95.5122 692.925 97.1136C692.881 96.8119 692.33 92.7421 694.45 91.0586C696.57 89.3752 697.627 89.6072 697.627 89.6072C695.864 88.5552 694.468 88.7584 693.366 89.1365Z"
            fill="url(#paint46_linear_6449_68769)"
          />
          <path
            d="M702.09 81.1932L702.985 81.8697C702.985 81.8697 702.192 79.8199 702.95 77.8815C703.708 75.9432 706.043 75.5033 706.817 75.4075C706.817 75.4075 704.898 74.3951 703.178 74.8296C701.457 75.2641 700.752 76.4902 700.639 78.0162C700.502 79.8475 702.09 81.1932 702.09 81.1932Z"
            fill="url(#paint47_linear_6449_68769)"
          />
          <path
            d="M702.09 81.1932L702.985 81.8697C702.985 81.8697 702.192 79.8199 702.95 77.8815C703.708 75.9432 706.043 75.5033 706.817 75.4075C706.817 75.4075 704.898 74.3951 703.178 74.8296C701.457 75.2641 700.752 76.4902 700.639 78.0162C700.502 79.8475 702.09 81.1932 702.09 81.1932Z"
            fill="url(#paint48_linear_6449_68769)"
          />
        </g>
        <mask
          id="mask22_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="690"
          y="74"
          width="17"
          height="24"
        >
          <path
            d="M693.366 89.1365C692.264 89.5147 691.246 90.82 690.991 92.182C690.736 93.544 691.203 95.5122 692.925 97.1136C692.882 96.8119 692.33 92.7421 694.45 91.0586C696.571 89.3752 697.628 89.6072 697.628 89.6072C695.865 88.5552 694.468 88.7584 693.366 89.1365Z"
            fill="url(#paint49_linear_6449_68769)"
          />
          <path
            d="M702.09 81.1932L702.986 81.8697C702.986 81.8697 702.193 79.8199 702.951 77.8815C703.709 75.9432 706.043 75.5033 706.818 75.4075C706.818 75.4075 704.898 74.3951 703.178 74.8296C701.458 75.2641 700.753 76.4902 700.639 78.0162C700.503 79.8475 702.09 81.1932 702.09 81.1932Z"
            fill="url(#paint50_linear_6449_68769)"
          />
        </mask>
        <g mask="url(#mask22_6449_68769)">
          <path d="M683.319 91.8267L698.722 69.2127" stroke="#9EECFF" strokeWidth="0.393282" />
          <path d="M684.203 92.4277L699.606 69.8137" stroke="#9EECFF" strokeWidth="0.393282" />
          <path d="M685.084 93.0288L700.487 70.4148" stroke="#9EECFF" strokeWidth="0.393282" />
          <path d="M685.97 93.6294L701.372 71.0154" stroke="#9EECFF" strokeWidth="0.393282" />
          <path d="M686.851 94.231L702.253 71.617" stroke="#9EECFF" strokeWidth="0.393282" />
          <path d="M687.73 94.832L703.133 72.218" stroke="#9EECFF" strokeWidth="0.393282" />
          <path d="M688.616 95.4321L704.019 72.8181" stroke="#9EECFF" strokeWidth="0.393282" />
          <path d="M689.499 96.0332L704.902 73.4192" stroke="#9EECFF" strokeWidth="0.393282" />
          <path d="M690.381 96.6338L705.784 74.0198" stroke="#9EECFF" strokeWidth="0.393282" />
          <path d="M691.261 97.2358L706.664 74.6218" stroke="#9EECFF" strokeWidth="0.393282" />
        </g>
        <circle cx="716.979" cy="107.756" r="0.330964" fill="white" />
        <g filter="url(#filter27_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="716.979" cy="107.756" r="0.330964" fill="white" />
        </g>
        <circle cx="721.144" cy="103.595" r="0.330964" fill="white" />
        <g filter="url(#filter28_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="721.144" cy="103.595" r="0.330964" fill="white" />
        </g>
        <circle cx="703.019" cy="119.361" r="0.177073" fill="white" />
        <g filter="url(#filter29_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="703.019" cy="119.361" r="0.177073" fill="white" />
        </g>
        <circle cx="713.412" cy="121.432" r="0.330964" fill="white" />
        <g filter="url(#filter30_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="713.412" cy="121.432" r="0.330964" fill="white" />
        </g>
        <circle cx="716.01" cy="126.702" r="0.128765" fill="white" />
        <g filter="url(#filter31_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="716.01" cy="126.702" r="0.128765" fill="white" />
        </g>
        <circle cx="723.146" cy="122.838" r="0.128765" fill="white" />
        <g filter="url(#filter32_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="723.146" cy="122.838" r="0.128765" fill="white" />
        </g>
        <circle cx="710.067" cy="117.19" r="0.128765" fill="white" />
        <g filter="url(#filter33_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="710.067" cy="117.19" r="0.128765" fill="white" />
        </g>
        <circle cx="710.362" cy="110.649" r="0.128765" fill="white" />
        <g filter="url(#filter34_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="710.362" cy="110.649" r="0.128765" fill="white" />
        </g>
        <circle cx="715.418" cy="105.298" r="0.128765" fill="white" />
        <g filter="url(#filter35_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="715.418" cy="105.298" r="0.128765" fill="white" />
        </g>
        <circle cx="722.55" cy="108.569" r="0.128765" fill="white" />
        <g filter="url(#filter36_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="722.55" cy="108.569" r="0.128765" fill="white" />
        </g>
        <circle cx="717.796" cy="103.514" r="0.128765" fill="white" />
        <g filter="url(#filter37_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="717.796" cy="103.514" r="0.128765" fill="white" />
        </g>
        <circle cx="726.119" cy="108.867" r="0.128765" fill="white" />
        <g filter="url(#filter38_f_6449_68769)" style={{mixBlendMode: 'plus-lighter'}}>
          <circle cx="726.119" cy="108.867" r="0.128765" fill="white" />
        </g>
        <path
          d="M1047.97 87.9137C1046.26 87.9137 1044.67 88.8285 1043.81 90.3136L1016.59 137.474C1015.73 138.959 1015.73 140.789 1016.59 142.274L1043.81 189.434C1044.67 190.919 1046.26 191.834 1047.97 191.834L1102.43 191.834C1104.14 191.834 1105.73 190.919 1106.58 189.434L1133.81 142.274C1134.67 140.789 1134.67 138.959 1133.81 137.474L1106.58 90.3136C1105.73 88.8285 1104.14 87.9137 1102.43 87.9137L1047.97 87.9137Z"
          fill="#5FED83"
        />
        <mask
          id="mask23_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="1015"
          y="87"
          width="120"
          height="105"
        >
          <path
            d="M1047.98 87.9108C1046.26 87.9108 1044.68 88.8256 1043.82 90.3107L1016.59 137.471C1015.73 138.956 1015.73 140.786 1016.59 142.271L1043.82 189.431C1044.68 190.916 1046.26 191.831 1047.98 191.831L1102.43 191.831C1104.15 191.831 1105.73 190.916 1106.59 189.431L1133.82 142.271C1134.67 140.786 1134.67 138.956 1133.82 137.471L1106.59 90.3107C1105.73 88.8256 1104.15 87.9108 1102.43 87.9108L1047.98 87.9108Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask23_6449_68769)">
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 1 -7.74287e-08 1045.24 87.9116)"
            fill="#8DF6A9"
          />
          <g filter="url(#filter39_i_6449_68769)">
            <rect
              width="59.9983"
              height="59.9983"
              rx="2.39993"
              transform="matrix(-0.5 0.866025 1 -7.74287e-08 1045.24 87.9116)"
              fill="white"
            />
          </g>
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 0.5 0.866025 1105.24 87.9111)"
            fill="url(#paint51_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 0.5 0.866025 1105.24 87.9111)"
            fill="url(#paint52_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1075.22 139.883)"
            fill="url(#paint53_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1075.22 139.883)"
            fill="url(#paint54_linear_6449_68769)"
            fillOpacity="0.5"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1075.22 139.883)"
            fill="url(#paint55_linear_6449_68769)"
            fillOpacity="0.2"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 -0.866025 1 -1.33041e-07 1016.78 139.005)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 -0.866025 0.5 0.866025 1076.9 138.941)"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(1 -1.33041e-07 0.5 0.866025 1016.86 138.927)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
        </g>
        <path
          d="M1107.97 191.831C1106.26 191.831 1104.67 190.916 1103.81 189.431L1076.59 142.271C1075.73 140.786 1075.73 138.956 1076.59 137.471L1103.81 90.3108C1104.67 88.8257 1106.26 87.9109 1107.97 87.9109L1162.43 87.9109C1164.14 87.9109 1165.73 88.8257 1166.58 90.3108L1193.81 137.471C1194.67 138.956 1194.67 140.786 1193.81 142.271L1166.58 189.431C1165.73 190.916 1164.14 191.831 1162.43 191.831L1107.97 191.831Z"
          fill="#5FED83"
        />
        <mask
          id="mask24_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="1075"
          y="87"
          width="120"
          height="105"
        >
          <path
            d="M1107.97 191.834C1106.26 191.834 1104.67 190.919 1103.82 189.434L1076.59 142.274C1075.73 140.789 1075.73 138.959 1076.59 137.474L1103.82 90.3137C1104.67 88.8286 1106.26 87.9138 1107.97 87.9138L1162.43 87.9138C1164.14 87.9138 1165.73 88.8286 1166.59 90.3137L1193.81 137.474C1194.67 138.959 1194.67 140.789 1193.81 142.274L1166.59 189.434C1165.73 190.919 1164.14 191.834 1162.43 191.834L1107.97 191.834Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask24_6449_68769)">
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 -0.866025 1 7.74287e-08 1105.24 191.833)"
            fill="#8DF6A9"
          />
          <g filter="url(#filter43_i_6449_68769)">
            <rect
              width="59.9983"
              height="59.9983"
              rx="2.39993"
              transform="matrix(-0.5 -0.866025 1 7.74287e-08 1105.24 191.833)"
              fill="white"
            />
          </g>
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 1165.24 191.833)"
            fill="url(#paint56_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 1165.24 191.833)"
            fill="url(#paint57_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 -7.74287e-08 0.5 -0.866025 1135.22 139.862)"
            fill="url(#paint58_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 -7.74287e-08 0.5 -0.866025 1135.22 139.862)"
            fill="url(#paint59_linear_6449_68769)"
            fillOpacity="0.5"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 -7.74287e-08 0.5 -0.866025 1135.22 139.862)"
            fill="url(#paint60_linear_6449_68769)"
            fillOpacity="0.2"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 0.866025 1 1.33041e-07 1076.77 140.739)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 0.866025 0.5 -0.866025 1136.9 140.803)"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(1 1.33041e-07 0.5 -0.866025 1076.86 140.818)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
        </g>
        <path
          d="M1167.97 87.9137C1166.26 87.9137 1164.67 88.8285 1163.81 90.3136L1136.59 137.474C1135.73 138.959 1135.73 140.789 1136.59 142.274L1163.81 189.434C1164.67 190.919 1166.26 191.834 1167.97 191.834L1222.43 191.834C1224.14 191.834 1225.73 190.919 1226.58 189.434L1253.81 142.274C1254.67 140.789 1254.67 138.959 1253.81 137.474L1226.58 90.3136C1225.73 88.8285 1224.14 87.9137 1222.43 87.9137L1167.97 87.9137Z"
          fill="#5FED83"
        />
        <mask
          id="mask25_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="1135"
          y="87"
          width="120"
          height="105"
        >
          <path
            d="M1167.97 87.9108C1166.26 87.9108 1164.67 88.8256 1163.82 90.3107L1136.59 137.471C1135.73 138.956 1135.73 140.786 1136.59 142.271L1163.82 189.431C1164.67 190.916 1166.26 191.831 1167.97 191.831L1222.43 191.831C1224.14 191.831 1225.73 190.916 1226.59 189.431L1253.81 142.271C1254.67 140.786 1254.67 138.956 1253.81 137.471L1226.59 90.3107C1225.73 88.8256 1224.14 87.9108 1222.43 87.9108L1167.97 87.9108Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask25_6449_68769)">
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 1 -7.74287e-08 1165.24 87.9111)"
            fill="#8DF6A9"
          />
          <g filter="url(#filter47_i_6449_68769)">
            <rect
              width="59.9983"
              height="59.9983"
              rx="2.39993"
              transform="matrix(-0.5 0.866025 1 -7.74287e-08 1165.24 87.9111)"
              fill="white"
            />
          </g>
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 0.5 0.866025 1225.24 87.9111)"
            fill="url(#paint61_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 0.5 0.866025 1225.24 87.9111)"
            fill="url(#paint62_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1195.22 139.883)"
            fill="url(#paint63_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1195.22 139.883)"
            fill="url(#paint64_linear_6449_68769)"
            fillOpacity="0.5"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1195.22 139.883)"
            fill="url(#paint65_linear_6449_68769)"
            fillOpacity="0.2"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 -0.866025 1 -1.33041e-07 1136.77 139.005)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 -0.866025 0.5 0.866025 1196.9 138.941)"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(1 -1.33041e-07 0.5 0.866025 1136.86 138.927)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
        </g>
        <path
          d="M1227.97 191.831C1226.26 191.831 1224.67 190.916 1223.81 189.431L1196.59 142.271C1195.73 140.786 1195.73 138.956 1196.59 137.471L1223.81 90.3108C1224.67 88.8257 1226.26 87.9109 1227.97 87.9109L1282.43 87.9109C1284.14 87.9109 1285.73 88.8257 1286.58 90.3108L1313.81 137.471C1314.67 138.956 1314.67 140.786 1313.81 142.271L1286.58 189.431C1285.73 190.916 1284.14 191.831 1282.43 191.831L1227.97 191.831Z"
          fill="#5FED83"
        />
        <mask
          id="mask26_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="1195"
          y="87"
          width="120"
          height="105"
        >
          <path
            d="M1227.97 191.834C1226.26 191.834 1224.67 190.919 1223.82 189.434L1196.59 142.274C1195.73 140.789 1195.73 138.959 1196.59 137.474L1223.82 90.3137C1224.67 88.8286 1226.26 87.9138 1227.97 87.9138L1282.43 87.9138C1284.14 87.9138 1285.73 88.8286 1286.59 90.3137L1313.81 137.474C1314.67 138.959 1314.67 140.789 1313.81 142.274L1286.59 189.434C1285.73 190.919 1284.14 191.834 1282.43 191.834L1227.97 191.834Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask26_6449_68769)">
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 -0.866025 1 7.74287e-08 1225.24 191.833)"
            fill="#8DF6A9"
          />
          <g filter="url(#filter51_i_6449_68769)">
            <rect
              width="59.9983"
              height="59.9983"
              rx="2.39993"
              transform="matrix(-0.5 -0.866025 1 7.74287e-08 1225.24 191.833)"
              fill="white"
            />
          </g>
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 1285.24 191.833)"
            fill="url(#paint66_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 1285.24 191.833)"
            fill="url(#paint67_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 -7.74287e-08 0.5 -0.866025 1255.22 139.862)"
            fill="url(#paint68_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 -7.74287e-08 0.5 -0.866025 1255.22 139.862)"
            fill="url(#paint69_linear_6449_68769)"
            fillOpacity="0.5"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 -7.74287e-08 0.5 -0.866025 1255.22 139.862)"
            fill="url(#paint70_linear_6449_68769)"
            fillOpacity="0.2"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 0.866025 1 1.33041e-07 1196.77 140.739)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 0.866025 0.5 -0.866025 1256.9 140.803)"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(1 1.33041e-07 0.5 -0.866025 1196.86 140.818)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
        </g>
        <path
          d="M1287.97 87.9137C1286.26 87.9137 1284.67 88.8285 1283.81 90.3136L1256.59 137.474C1255.73 138.959 1255.73 140.789 1256.59 142.274L1283.81 189.434C1284.67 190.919 1286.26 191.834 1287.97 191.834L1342.43 191.834C1344.14 191.834 1345.73 190.919 1346.58 189.434L1373.81 142.274C1374.67 140.789 1374.67 138.959 1373.81 137.474L1346.58 90.3136C1345.73 88.8285 1344.14 87.9137 1342.43 87.9137L1287.97 87.9137Z"
          fill="#5FED83"
        />
        <mask
          id="mask27_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="1255"
          y="87"
          width="120"
          height="105"
        >
          <path
            d="M1287.97 87.9108C1286.26 87.9108 1284.67 88.8256 1283.82 90.3107L1256.59 137.471C1255.73 138.956 1255.73 140.786 1256.59 142.271L1283.82 189.431C1284.67 190.916 1286.26 191.831 1287.97 191.831L1342.43 191.831C1344.14 191.831 1345.73 190.916 1346.59 189.431L1373.81 142.271C1374.67 140.786 1374.67 138.956 1373.81 137.471L1346.59 90.3107C1345.73 88.8256 1344.14 87.9108 1342.43 87.9108L1287.97 87.9108Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask27_6449_68769)">
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 1 -7.74287e-08 1285.24 87.9111)"
            fill="#8DF6A9"
          />
          <g filter="url(#filter55_i_6449_68769)">
            <rect
              width="59.9983"
              height="59.9983"
              rx="2.39993"
              transform="matrix(-0.5 0.866025 1 -7.74287e-08 1285.24 87.9111)"
              fill="white"
            />
          </g>
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 0.5 0.866025 1345.24 87.9111)"
            fill="url(#paint71_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 0.5 0.866025 1345.24 87.9111)"
            fill="url(#paint72_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1315.22 139.883)"
            fill="url(#paint73_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1315.22 139.883)"
            fill="url(#paint74_linear_6449_68769)"
            fillOpacity="0.5"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1315.22 139.883)"
            fill="url(#paint75_linear_6449_68769)"
            fillOpacity="0.2"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 -0.866025 1 -1.33041e-07 1256.77 139.005)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 -0.866025 0.5 0.866025 1316.9 138.941)"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(1 -1.33041e-07 0.5 0.866025 1256.86 138.927)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
        </g>
        <path
          d="M1347.97 191.831C1346.26 191.831 1344.67 190.916 1343.81 189.431L1316.59 142.271C1315.73 140.786 1315.73 138.956 1316.59 137.471L1343.81 90.3108C1344.67 88.8257 1346.26 87.9109 1347.97 87.9109L1402.43 87.9109C1404.14 87.9109 1405.73 88.8257 1406.58 90.3108L1433.81 137.471C1434.67 138.956 1434.67 140.786 1433.81 142.271L1406.58 189.431C1405.73 190.916 1404.14 191.831 1402.43 191.831L1347.97 191.831Z"
          fill="#5FED83"
        />
        <mask
          id="mask28_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="1315"
          y="87"
          width="120"
          height="105"
        >
          <path
            d="M1347.97 191.834C1346.26 191.834 1344.67 190.919 1343.82 189.434L1316.59 142.274C1315.73 140.789 1315.73 138.959 1316.59 137.474L1343.82 90.3137C1344.67 88.8286 1346.26 87.9138 1347.97 87.9138L1402.43 87.9138C1404.14 87.9138 1405.73 88.8286 1406.59 90.3137L1433.81 137.474C1434.67 138.959 1434.67 140.789 1433.81 142.274L1406.59 189.434C1405.73 190.919 1404.14 191.834 1402.43 191.834L1347.97 191.834Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask28_6449_68769)">
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 -0.866025 1 7.74287e-08 1345.24 191.833)"
            fill="#8DF6A9"
          />
          <g filter="url(#filter59_i_6449_68769)">
            <rect
              width="59.9983"
              height="59.9983"
              rx="2.39993"
              transform="matrix(-0.5 -0.866025 1 7.74287e-08 1345.24 191.833)"
              fill="white"
            />
          </g>
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 1405.24 191.833)"
            fill="url(#paint76_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 1405.24 191.833)"
            fill="url(#paint77_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 -7.74287e-08 0.5 -0.866025 1375.22 139.862)"
            fill="url(#paint78_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 -7.74287e-08 0.5 -0.866025 1375.22 139.862)"
            fill="url(#paint79_linear_6449_68769)"
            fillOpacity="0.5"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 -7.74287e-08 0.5 -0.866025 1375.22 139.862)"
            fill="url(#paint80_linear_6449_68769)"
            fillOpacity="0.2"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 0.866025 1 1.33041e-07 1316.77 140.739)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 0.866025 0.5 -0.866025 1376.9 140.803)"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(1 1.33041e-07 0.5 -0.866025 1316.86 140.818)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
        </g>
        <path
          d="M1407.97 87.9137C1406.26 87.9137 1404.67 88.8285 1403.81 90.3136L1376.59 137.474C1375.73 138.959 1375.73 140.789 1376.59 142.274L1403.81 189.434C1404.67 190.919 1406.26 191.834 1407.97 191.834L1462.43 191.834C1464.14 191.834 1465.73 190.919 1466.58 189.434L1493.81 142.274C1494.67 140.789 1494.67 138.959 1493.81 137.474L1466.58 90.3136C1465.73 88.8285 1464.14 87.9137 1462.43 87.9137L1407.97 87.9137Z"
          fill="#5FED83"
        />
        <mask
          id="mask29_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="1375"
          y="87"
          width="120"
          height="105"
        >
          <path
            d="M1407.97 87.9108C1406.26 87.9108 1404.67 88.8256 1403.82 90.3107L1376.59 137.471C1375.73 138.956 1375.73 140.786 1376.59 142.271L1403.82 189.431C1404.67 190.916 1406.26 191.831 1407.97 191.831L1462.43 191.831C1464.14 191.831 1465.73 190.916 1466.59 189.431L1493.81 142.271C1494.67 140.786 1494.67 138.956 1493.81 137.471L1466.59 90.3107C1465.73 88.8256 1464.14 87.9108 1462.43 87.9108L1407.97 87.9108Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask29_6449_68769)">
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 1 -7.74287e-08 1405.24 87.9111)"
            fill="#8DF6A9"
          />
          <g filter="url(#filter63_i_6449_68769)">
            <rect
              width="59.9983"
              height="59.9983"
              rx="2.39993"
              transform="matrix(-0.5 0.866025 1 -7.74287e-08 1405.24 87.9111)"
              fill="white"
            />
          </g>
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 0.5 0.866025 1465.24 87.9111)"
            fill="url(#paint81_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            transform="matrix(-0.5 0.866025 0.5 0.866025 1465.24 87.9111)"
            fill="url(#paint82_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1435.22 139.883)"
            fill="url(#paint83_linear_6449_68769)"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1435.22 139.883)"
            fill="url(#paint84_linear_6449_68769)"
            fillOpacity="0.5"
          />
          <rect
            width="59.9983"
            height="59.9983"
            rx="4.22691"
            transform="matrix(-1 7.74287e-08 0.5 0.866025 1435.22 139.883)"
            fill="url(#paint85_linear_6449_68769)"
            fillOpacity="0.2"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 -0.866025 1 -1.33041e-07 1376.77 139.005)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(0.5 -0.866025 0.5 0.866025 1436.9 138.941)"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            width="60.0701"
            height="60.0701"
            rx="1.90211"
            transform="matrix(1 -1.33041e-07 0.5 0.866025 1376.86 138.927)"
            fill="#82E8FF"
            fillOpacity="0.1"
          />
        </g>
        <mask
          id="mask30_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="106"
          y="80"
          width="119"
          height="105"
        >
          <path
            d="M138.157 80.4517C136.442 80.4517 134.857 81.3665 134 82.8517L106.771 130.013C105.914 131.498 105.914 133.328 106.771 134.813L134 181.975C134.857 183.46 136.442 184.375 138.157 184.375L192.614 184.375C194.329 184.375 195.914 183.46 196.771 181.975L224 134.813C224.857 133.328 224.857 131.498 224 130.013L196.771 82.8517C195.914 81.3665 194.329 80.4517 192.614 80.4517L138.157 80.4517Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask30_6449_68769)">
          <rect width="60" height="60" transform="matrix(-0.5 0.866025 1 1.07231e-07 135.429 80.4507)" fill="#8DF6A9" />
          <g filter="url(#filter67_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-0.5 0.866025 1 1.07231e-07 135.429 80.4507)"
              fill="#028E29"
            />
          </g>
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 0.866025 0.5 0.866025 195.431 80.4507)"
            fill="url(#paint86_linear_6449_68769)"
          />
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 0.866025 0.5 0.866025 195.431 80.4507)"
            fill="url(#paint87_linear_6449_68769)"
          />
          <g filter="url(#filter68_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-1 3.99275e-09 0.5 0.866025 165.414 132.423)"
              fill="#BFFFD1"
            />
          </g>
        </g>
        <mask
          id="mask31_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="167"
          y="80"
          width="119"
          height="105"
        >
          <path
            d="M199.156 184.375C197.442 184.375 195.857 183.46 195 181.975L167.771 134.813C166.913 133.328 166.913 131.498 167.771 130.013L195 82.8515C195.857 81.3663 197.442 80.4515 199.156 80.4515L253.614 80.4515C255.329 80.4515 256.913 81.3663 257.771 82.8515L285 130.013C285.857 131.498 285.857 133.328 285 134.813L257.771 181.975C256.913 183.46 255.329 184.375 253.614 184.375L199.156 184.375Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask31_6449_68769)">
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 -0.866025 1 -1.07231e-07 196.428 184.375)"
            fill="#8DF6A9"
          />
          <g filter="url(#filter69_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-0.5 -0.866025 1 -1.07231e-07 196.428 184.375)"
              fill="#028E29"
            />
          </g>
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 256.43 184.375)"
            fill="url(#paint88_linear_6449_68769)"
          />
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 256.43 184.375)"
            fill="url(#paint89_linear_6449_68769)"
          />
          <g filter="url(#filter70_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-1 -3.99275e-09 0.5 -0.866025 226.413 132.403)"
              fill="#BFFFD1"
            />
          </g>
        </g>
        <mask
          id="mask32_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="228"
          y="80"
          width="119"
          height="105"
        >
          <path
            d="M260.156 80.4517C258.442 80.4517 256.857 81.3665 256 82.8517L228.771 130.013C227.913 131.498 227.913 133.328 228.771 134.813L256 181.975C256.857 183.46 258.442 184.375 260.156 184.375L314.614 184.375C316.329 184.375 317.913 183.46 318.771 181.975L346 134.813C346.857 133.328 346.857 131.498 346 130.013L318.771 82.8517C317.913 81.3665 316.329 80.4517 314.614 80.4517L260.156 80.4517Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask32_6449_68769)">
          <rect width="60" height="60" transform="matrix(-0.5 0.866025 1 1.07231e-07 257.428 80.4507)" fill="#8DF6A9" />
          <g filter="url(#filter71_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-0.5 0.866025 1 1.07231e-07 257.428 80.4507)"
              fill="#028E29"
            />
          </g>
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 0.866025 0.5 0.866025 317.43 80.4507)"
            fill="url(#paint90_linear_6449_68769)"
          />
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 0.866025 0.5 0.866025 317.43 80.4507)"
            fill="url(#paint91_linear_6449_68769)"
          />
          <g filter="url(#filter72_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-1 3.99275e-09 0.5 0.866025 287.413 132.423)"
              fill="#BFFFD1"
            />
          </g>
        </g>
        <mask
          id="mask33_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="289"
          y="80"
          width="119"
          height="105"
        >
          <path
            d="M321.156 184.375C319.442 184.375 317.857 183.46 317 181.975L289.771 134.813C288.913 133.328 288.913 131.498 289.771 130.013L317 82.8515C317.857 81.3663 319.442 80.4515 321.156 80.4515L375.614 80.4515C377.329 80.4515 378.913 81.3663 379.771 82.8515L407 130.013C407.857 131.498 407.857 133.328 407 134.813L379.771 181.975C378.913 183.46 377.329 184.375 375.614 184.375L321.156 184.375Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask33_6449_68769)">
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 -0.866025 1 -1.07231e-07 318.428 184.375)"
            fill="#8DF6A9"
          />
          <g filter="url(#filter73_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-0.5 -0.866025 1 -1.07231e-07 318.428 184.375)"
              fill="#028E29"
            />
          </g>
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 378.43 184.375)"
            fill="url(#paint92_linear_6449_68769)"
          />
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 -0.866025 0.5 -0.866025 378.43 184.375)"
            fill="url(#paint93_linear_6449_68769)"
          />
          <g filter="url(#filter74_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-1 -3.99275e-09 0.5 -0.866025 348.413 132.404)"
              fill="#BFFFD1"
            />
          </g>
        </g>
        <rect
          width="60.0128"
          height="60.0128"
          rx="1.90029"
          transform="matrix(0.5 0.866025 -0.5 0.866025 499.767 79.6069)"
          fill="url(#paint94_linear_6449_68769)"
          fillOpacity="0.8"
        />
        <rect
          width="60.0128"
          height="60.0128"
          rx="1.90029"
          transform="matrix(0.5 0.866025 -1 -4.37114e-08 469.787 131.663)"
          fill="url(#paint95_linear_6449_68769)"
          fillOpacity="0.7"
        />
        <rect
          width="60.0128"
          height="60.0128"
          rx="1.90029"
          transform="matrix(-0.5 0.866025 -1 -4.37114e-08 499.792 79.7207)"
          fill="url(#paint96_linear_6449_68769)"
          fillOpacity="0.6"
        />
        <mask
          id="mask34_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="350"
          y="80"
          width="119"
          height="105"
        >
          <path
            d="M382.156 80.4517C380.442 80.4517 378.857 81.3665 378 82.8517L350.771 130.013C349.913 131.498 349.913 133.328 350.771 134.813L378 181.975C378.857 183.46 380.442 184.375 382.156 184.375L436.614 184.375C438.329 184.375 439.913 183.46 440.771 181.975L468 134.813C468.857 133.328 468.857 131.498 468 130.013L440.771 82.8517C439.913 81.3665 438.329 80.4517 436.614 80.4517L382.156 80.4517Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask34_6449_68769)">
          <rect width="60" height="60" transform="matrix(-0.5 0.866025 1 1.07231e-07 379.428 80.4507)" fill="#8DF6A9" />
          <g filter="url(#filter78_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-0.5 0.866025 1 1.07231e-07 379.428 80.4507)"
              fill="#028E29"
            />
          </g>
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 0.866025 0.5 0.866025 439.43 80.4507)"
            fill="url(#paint97_linear_6449_68769)"
          />
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 0.866025 0.5 0.866025 439.43 80.4507)"
            fill="url(#paint98_linear_6449_68769)"
          />
          <g filter="url(#filter79_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-1 3.99275e-09 0.5 0.866025 409.413 132.422)"
              fill="#BFFFD1"
            />
          </g>
        </g>
        <mask
          id="mask35_6449_68769"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="506"
          y="79"
          width="119"
          height="105"
        >
          <path
            d="M538.156 79.4517C536.442 79.4517 534.857 80.3665 534 81.8517L506.771 129.013C505.913 130.498 505.913 132.328 506.771 133.813L534 180.975C534.857 182.46 536.442 183.375 538.156 183.375L592.614 183.375C594.329 183.375 595.913 182.46 596.771 180.975L624 133.813C624.857 132.328 624.857 130.498 624 129.013L596.771 81.8517C595.913 80.3665 594.329 79.4517 592.614 79.4517L538.156 79.4517Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask35_6449_68769)">
          <rect width="60" height="60" transform="matrix(-0.5 0.866025 1 1.07231e-07 535.423 79.4512)" fill="#8DF6A9" />
          <g filter="url(#filter80_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-0.5 0.866025 1 1.07231e-07 535.423 79.4512)"
              fill="#028E29"
            />
          </g>
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 0.866025 0.5 0.866025 595.425 79.4512)"
            fill="url(#paint99_linear_6449_68769)"
          />
          <rect
            width="60"
            height="60"
            transform="matrix(-0.5 0.866025 0.5 0.866025 595.425 79.4512)"
            fill="url(#paint100_linear_6449_68769)"
          />
          <g filter="url(#filter81_i_6449_68769)">
            <rect
              width="60"
              height="60"
              rx="2.4"
              transform="matrix(-1 3.99275e-09 0.5 0.866025 565.408 131.423)"
              fill="#BFFFD1"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_6449_68769"
          x="842.811"
          y="70.127"
          width="77.5791"
          height="131.635"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="2.14993" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="8.95805" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter1_f_6449_68769"
          x="693.64"
          y="85.8849"
          width="186.454"
          height="61.6667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.10247" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter2_f_6449_68769"
          x="695.422"
          y="95.3971"
          width="74.677"
          height="47.3269"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.10247" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter3_f_6449_68769"
          x="668.789"
          y="55.2107"
          width="56.2432"
          height="60.5284"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="6.72426" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter4_f_6449_68769"
          x="664.113"
          y="56.1838"
          width="35.883"
          height="48.5666"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1.29069" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter5_f_6449_68769"
          x="664.722"
          y="41.152"
          width="55.3561"
          height="55.3561"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.19133" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter6_f_6449_68769"
          x="641.892"
          y="60.028"
          width="53.0637"
          height="53.0637"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.19133" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter7_f_6449_68769"
          x="667.908"
          y="57.7291"
          width="63.5838"
          height="65.032"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.08491" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter8_f_6449_68769"
          x="638.071"
          y="37.6422"
          width="72.6594"
          height="72.6589"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.19133" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter9_f_6449_68769"
          x="607.611"
          y="78.4313"
          width="77.1369"
          height="80.114"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.63884" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter10_f_6449_68769"
          x="613.285"
          y="103.193"
          width="62.509"
          height="64.7482"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.63884" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter11_f_6449_68769"
          x="660.257"
          y="109.744"
          width="55.236"
          height="44.5896"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.63884" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter12_f_6449_68769"
          x="677.562"
          y="121.242"
          width="15.2881"
          height="12.5806"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1.52809" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter13_i_6449_68769"
          x="661.868"
          y="124.756"
          width="13.0918"
          height="9.32426"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.218298" />
          <feGaussianBlur stdDeviation="1.60722" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.784314 0 0 0 0 0.996078 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter14_f_6449_68769"
          x="652.448"
          y="52.2913"
          width="39.203"
          height="40.7055"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.42857" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter15_f_6449_68769"
          x="679.819"
          y="43.5804"
          width="39.203"
          height="40.7055"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.42857" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter16_f_6449_68769"
          x="668.492"
          y="42.1302"
          width="46.201"
          height="58.9154"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.38363" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter17_f_6449_68769"
          x="662.616"
          y="40.011"
          width="31.5229"
          height="27.6366"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.42857" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter18_f_6449_68769"
          x="686.643"
          y="49.3299"
          width="17.3075"
          height="25.3783"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.42857" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter19_f_6449_68769"
          x="661.374"
          y="42.0218"
          width="26.2328"
          height="23.6347"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.42857" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter20_f_6449_68769"
          x="657.776"
          y="61.8691"
          width="51.6193"
          height="52.7668"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4.22953" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter21_f_6449_68769"
          x="666.931"
          y="68.8854"
          width="34.6111"
          height="35.2674"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.68379" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter22_f_6449_68769"
          x="642.729"
          y="64.3987"
          width="36.3031"
          height="31.5649"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.42857" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter23_f_6449_68769"
          x="673.317"
          y="66.0657"
          width="18.6982"
          height="22.9189"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.42857" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter24_f_6449_68769"
          x="641.22"
          y="66.8489"
          width="29.853"
          height="26.686"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.42857" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter25_f_6449_68769"
          x="666.62"
          y="67.8289"
          width="21.5209"
          height="20.4692"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.42857" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter26_f_6449_68769"
          x="688.605"
          y="72.4008"
          width="20.5323"
          height="27.0333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1.16018" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter27_f_6449_68769"
          x="715.536"
          y="106.313"
          width="2.8868"
          height="2.8868"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.556173" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter28_f_6449_68769"
          x="719.701"
          y="102.151"
          width="2.8868"
          height="2.8868"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.556173" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter29_f_6449_68769"
          x="702.247"
          y="118.588"
          width="1.54427"
          height="1.54427"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.297565" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter30_f_6449_68769"
          x="711.968"
          y="119.988"
          width="2.8868"
          height="2.8868"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.556173" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter31_f_6449_68769"
          x="715.449"
          y="126.141"
          width="1.12287"
          height="1.12287"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.216385" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter32_f_6449_68769"
          x="722.584"
          y="122.277"
          width="1.12287"
          height="1.12287"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.216385" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter33_f_6449_68769"
          x="709.506"
          y="116.629"
          width="1.12287"
          height="1.12287"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.216385" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter34_f_6449_68769"
          x="709.801"
          y="110.088"
          width="1.12287"
          height="1.12287"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.216385" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter35_f_6449_68769"
          x="714.857"
          y="104.737"
          width="1.12287"
          height="1.12287"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.216385" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter36_f_6449_68769"
          x="721.989"
          y="108.007"
          width="1.12287"
          height="1.12287"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.216385" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter37_f_6449_68769"
          x="717.234"
          y="102.952"
          width="1.12287"
          height="1.12287"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.216385" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter38_f_6449_68769"
          x="725.557"
          y="108.306"
          width="1.12287"
          height="1.12287"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.216385" result="effect1_foregroundBlur_6449_68769" />
        </filter>
        <filter
          id="filter39_i_6449_68769"
          x="1016.16"
          y="87.9116"
          width="88.165"
          height="51.96"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.43996" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="5.99983" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.619608 0 0 0 0 0.92549 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter43_i_6449_68769"
          x="1076.16"
          y="139.874"
          width="88.165"
          height="51.96"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.43996" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="5.99983" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.619608 0 0 0 0 0.92549 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter47_i_6449_68769"
          x="1136.16"
          y="87.9111"
          width="88.165"
          height="51.96"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.43996" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="5.99983" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.619608 0 0 0 0 0.92549 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter51_i_6449_68769"
          x="1196.16"
          y="139.874"
          width="88.165"
          height="51.96"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.43996" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="5.99983" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.619608 0 0 0 0 0.92549 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter55_i_6449_68769"
          x="1256.16"
          y="87.9111"
          width="88.165"
          height="51.96"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.43996" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="5.99983" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.619608 0 0 0 0 0.92549 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter59_i_6449_68769"
          x="1316.16"
          y="139.874"
          width="88.165"
          height="51.96"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.43996" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="5.99983" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.619608 0 0 0 0 0.92549 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter63_i_6449_68769"
          x="1376.16"
          y="87.9111"
          width="88.165"
          height="51.96"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.43996" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="5.99983" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.619608 0 0 0 0 0.92549 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter67_i_6449_68769"
          x="106.345"
          y="80.4507"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter68_i_6449_68769"
          x="106.33"
          y="132.423"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter69_i_6449_68769"
          x="167.344"
          y="132.414"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter70_i_6449_68769"
          x="167.329"
          y="80.4419"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter71_i_6449_68769"
          x="228.344"
          y="80.4507"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter72_i_6449_68769"
          x="228.329"
          y="132.423"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter73_i_6449_68769"
          x="289.344"
          y="132.414"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter74_i_6449_68769"
          x="289.329"
          y="80.4424"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter78_i_6449_68769"
          x="350.344"
          y="80.4507"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter79_i_6449_68769"
          x="350.329"
          y="132.422"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter80_i_6449_68769"
          x="506.339"
          y="79.4512"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <filter
          id="filter81_i_6449_68769"
          x="506.324"
          y="131.423"
          width="88.168"
          height="51.9614"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1.44" operator="erode" in="SourceAlpha" result="effect1_innerShadow_6449_68769" />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.929412 0 0 0 0 0.513726 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6449_68769" />
        </filter>
        <linearGradient
          id="paint0_linear_6449_68769"
          x1="44.7903"
          y1="0"
          x2="44.7903"
          y2="111.948"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6449_68769"
          x1="44.7903"
          y1="0"
          x2="44.7903"
          y2="89.5805"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6449_68769"
          x1="701.845"
          y1="116.718"
          x2="871.889"
          y2="116.718"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.591346" stopColor="#9EECFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6449_68769"
          x1="667.023"
          y1="67.7135"
          x2="742.305"
          y2="101.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.10683" stopColor="white" />
          <stop offset="0.416855" stopColor="#9EECFF" />
          <stop offset="0.645002" stopColor="#3094FF" />
          <stop offset="1" stopColor="#5FED83" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6449_68769"
          x1="659.634"
          y1="68.1458"
          x2="711.96"
          y2="98.3719"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.105932" stopColor="#0527FC" />
          <stop offset="0.82436" stopColor="#000F71" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6449_68769"
          x1="667.021"
          y1="67.713"
          x2="742.303"
          y2="101.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.10683" stopColor="white" />
          <stop offset="0.416855" stopColor="#9EECFF" />
          <stop offset="0.645002" stopColor="#3094FF" />
          <stop offset="1" stopColor="#5FED83" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6449_68769"
          x1="659.632"
          y1="68.1453"
          x2="711.958"
          y2="98.3714"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.105932" stopColor="#0527FC" />
          <stop offset="0.82436" stopColor="#000F71" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6449_68769"
          x1="696.146"
          y1="111.616"
          x2="704.67"
          y2="114.482"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFFFD1" />
          <stop offset="0.285" stopColor="#9EECFF" />
          <stop offset="0.795071" stopColor="#0527FC" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6449_68769"
          x1="683.566"
          y1="110.286"
          x2="703.335"
          y2="114.847"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFFFD1" />
          <stop offset="0.285" stopColor="#9EECFF" />
          <stop offset="0.795071" stopColor="#0527FC" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_6449_68769"
          x1="714.018"
          y1="67.3521"
          x2="691.775"
          y2="68.8574"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.195122" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0527FC" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_6449_68769"
          x1="714.021"
          y1="67.3521"
          x2="691.778"
          y2="68.8574"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.195122" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0527FC" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_6449_68769"
          x1="689.656"
          y1="120.463"
          x2="661.857"
          y2="89.4905"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0119B3" />
          <stop offset="0.479015" stopColor="#334FFF" />
          <stop offset="0.911607" stopColor="#D0B0FF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_6449_68769"
          x1="689.655"
          y1="120.463"
          x2="661.857"
          y2="89.4905"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0119B3" />
          <stop offset="0.479015" stopColor="#334FFF" />
          <stop offset="0.911607" stopColor="#D0B0FF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_6449_68769"
          x1="680.599"
          y1="129.602"
          x2="729.267"
          y2="111.522"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFFFD1" />
          <stop offset="0.285" stopColor="#9EECFF" />
          <stop offset="0.795071" stopColor="#0527FC" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_6449_68769"
          x1="688.191"
          y1="24.3342"
          x2="747.463"
          y2="62.2437"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0770484" stopColor="#FF80D2" />
          <stop offset="0.439954" stopColor="#8342FA" />
          <stop offset="0.771083" stopColor="#3094FF" />
          <stop offset="1" stopColor="#9EECFF" />
          <stop offset="1" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_6449_68769"
          x1="716.148"
          y1="82.8213"
          x2="696.025"
          y2="61.6719"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0739736" stopColor="#334FFF" />
          <stop offset="0.542173" stopColor="#D0B0FF" />
          <stop offset="1" stopColor="#9EECFF" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_6449_68769"
          x1="716.15"
          y1="82.8213"
          x2="694.449"
          y2="63.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0739736" stopColor="#334FFF" />
          <stop offset="1" stopColor="#D0B0FF" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_6449_68769"
          x1="647.538"
          y1="75.2562"
          x2="659.098"
          y2="79.1534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFFFD1" />
          <stop offset="0.285" stopColor="#9EECFF" />
          <stop offset="0.795071" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_6449_68769"
          x1="647.537"
          y1="75.2562"
          x2="659.097"
          y2="79.1534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFFFD1" />
          <stop offset="0.285" stopColor="#9EECFF" />
          <stop offset="0.795071" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_6449_68769"
          x1="647.745"
          y1="75.3758"
          x2="659.039"
          y2="79.238"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFFFD1" />
          <stop offset="0.285" stopColor="#9EECFF" />
          <stop offset="0.795071" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_6449_68769"
          x1="651.894"
          y1="100.236"
          x2="645.955"
          y2="88.4162"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0739736" stopColor="#334FFF" />
          <stop offset="1" stopColor="#D0B0FF" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_6449_68769"
          x1="641.591"
          y1="113.973"
          x2="680.384"
          y2="123.155"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.40704" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0527FC" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_6449_68769"
          x1="641.589"
          y1="113.973"
          x2="680.382"
          y2="123.155"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.40704" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0527FC" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_6449_68769"
          x1="668.414"
          y1="92.3894"
          x2="669.291"
          y2="142.867"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.203834" stopColor="#0527FC" />
          <stop offset="0.522003" stopColor="#8342FA" />
          <stop offset="1" stopColor="#C06EFF" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_6449_68769"
          x1="649.892"
          y1="70.4746"
          x2="696.653"
          y2="89.7878"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.10683" stopColor="white" />
          <stop offset="0.416855" stopColor="#9EECFF" />
          <stop offset="0.645002" stopColor="#3094FF" />
          <stop offset="1" stopColor="#5FED83" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_6449_68769"
          x1="658.252"
          y1="77.4397"
          x2="677.819"
          y2="88.7367"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.105932" stopColor="#0527FC" />
          <stop offset="1" stopColor="#000F71" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_6449_68769"
          x1="654.349"
          y1="44.4172"
          x2="720.755"
          y2="69.4561"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.10683" stopColor="white" />
          <stop offset="0.416855" stopColor="#9EECFF" />
          <stop offset="0.645002" stopColor="#3094FF" />
          <stop offset="1" stopColor="#5FED83" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_6449_68769"
          x1="666.383"
          y1="53.7961"
          x2="693.958"
          y2="69.7165"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.105932" stopColor="#0527FC" />
          <stop offset="1" stopColor="#000F71" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_6449_68769"
          x1="696.992"
          y1="72.7718"
          x2="686.268"
          y2="77.0523"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0451883" stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_6449_68769"
          x1="696.995"
          y1="72.7718"
          x2="686.272"
          y2="77.0523"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0451883" stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_6449_68769"
          x1="671.673"
          y1="37.3847"
          x2="697.482"
          y2="43.0603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_6449_68769"
          x1="671.67"
          y1="37.3862"
          x2="697.479"
          y2="43.0618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_6449_68769"
          x1="695.999"
          y1="50.778"
          x2="673.264"
          y2="103.921"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.200354" stopColor="#0527FC" />
          <stop offset="1" stopColor="#C06EFF" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_6449_68769"
          x1="671.67"
          y1="37.3857"
          x2="697.479"
          y2="43.0613"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_6449_68769"
          x1="675.09"
          y1="44.3928"
          x2="692.031"
          y2="48.1746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_6449_68769"
          x1="661.54"
          y1="57.7293"
          x2="686.332"
          y2="65.3037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_6449_68769"
          x1="661.544"
          y1="57.7289"
          x2="686.335"
          y2="65.3034"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_6449_68769"
          x1="650.705"
          y1="48.4726"
          x2="687.929"
          y2="59.4453"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0451883" stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_6449_68769"
          x1="655.939"
          y1="58.4261"
          x2="681.713"
          y2="66.0231"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0451883" stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_6449_68769"
          x1="684.857"
          y1="85.9307"
          x2="656.349"
          y2="96.758"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0451883" stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_6449_68769"
          x1="686.604"
          y1="86.0432"
          x2="657.859"
          y2="90.8652"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0451883" stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_6449_68769"
          x1="650.705"
          y1="48.4718"
          x2="687.929"
          y2="59.4444"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0451883" stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_6449_68769"
          x1="655.938"
          y1="58.4251"
          x2="681.711"
          y2="66.0221"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0451883" stopColor="#9EECFF" />
          <stop offset="0.665" stopColor="#3094FF" />
          <stop offset="1" stopColor="#0072EB" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_6449_68769"
          x1="690.403"
          y1="80.0639"
          x2="699.908"
          y2="86.5375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.65" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_6449_68769"
          x1="690.403"
          y1="80.0639"
          x2="699.908"
          y2="86.5375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.65" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_6449_68769"
          x1="696.082"
          y1="83.6797"
          x2="700.176"
          y2="86.4681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D3FA37" />
          <stop offset="0.65" stopColor="#BFFFD1" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_6449_68769"
          x1="696.082"
          y1="83.6797"
          x2="700.176"
          y2="86.4681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.65" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_6449_68769"
          x1="696.082"
          y1="83.6797"
          x2="700.176"
          y2="86.4681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D3FA37" />
          <stop offset="0.65" stopColor="#BFFFD1" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_6449_68769"
          x1="696.082"
          y1="83.6797"
          x2="700.176"
          y2="86.4681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.65" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_6449_68769"
          x1="690.404"
          y1="80.0639"
          x2="699.908"
          y2="86.5375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.65" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_6449_68769"
          x1="690.404"
          y1="80.0639"
          x2="699.908"
          y2="86.5375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="0.65" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#DEFEFA" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_6449_68769"
          x1="29.9991"
          y1="59.9983"
          x2="29.9991"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="1" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#DEFEFA" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_6449_68769"
          x1="29.9991"
          y1="59.9983"
          x2="29.9991"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="1" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#DEFEFA" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_6449_68769"
          x1="29.9991"
          y1="59.9983"
          x2="29.9991"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="1" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#DEFEFA" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_6449_68769"
          x1="29.9991"
          y1="59.9983"
          x2="29.9991"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="1" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#DEFEFA" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint75_linear_6449_68769"
          x1="29.9991"
          y1="59.9983"
          x2="29.9991"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="1" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint76_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint77_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#DEFEFA" />
        </linearGradient>
        <linearGradient
          id="paint78_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint79_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint80_linear_6449_68769"
          x1="29.9991"
          y1="59.9983"
          x2="29.9991"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="1" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint81_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint82_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#DEFEFA" />
        </linearGradient>
        <linearGradient
          id="paint83_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="74.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient
          id="paint84_linear_6449_68769"
          x1="29.9991"
          y1="0"
          x2="29.9991"
          y2="59.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint85_linear_6449_68769"
          x1="29.9991"
          y1="59.9983"
          x2="29.9991"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EECFF" />
          <stop offset="1" stopColor="#3094FF" />
        </linearGradient>
        <linearGradient
          id="paint86_linear_6449_68769"
          x1="30"
          y1="0"
          x2="30"
          y2="74.9816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient id="paint87_linear_6449_68769" x1="30" y1="0" x2="30" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint88_linear_6449_68769"
          x1="30"
          y1="0"
          x2="30"
          y2="74.9816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient id="paint89_linear_6449_68769" x1="30" y1="0" x2="30" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint90_linear_6449_68769"
          x1="30"
          y1="0"
          x2="30"
          y2="74.9816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient id="paint91_linear_6449_68769" x1="30" y1="0" x2="30" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint92_linear_6449_68769"
          x1="30"
          y1="0"
          x2="30"
          y2="74.9816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient id="paint93_linear_6449_68769" x1="30" y1="0" x2="30" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint94_linear_6449_68769"
          x1="30.0064"
          y1="0"
          x2="30.0064"
          y2="60.0128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEFEFA" />
          <stop offset="1" stopColor="#DEFEFA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint95_linear_6449_68769"
          x1="74.2294"
          y1="-11.0501"
          x2="95.8935"
          y2="76.0954"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEFEFA" />
          <stop offset="1" stopColor="#DEFEFA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint96_linear_6449_68769"
          x1="0.111817"
          y1="-9.76852"
          x2="29.6027"
          y2="51.929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEFEFA" />
          <stop offset="1" stopColor="#DEFEFA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint97_linear_6449_68769"
          x1="30"
          y1="0"
          x2="30"
          y2="74.9816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient id="paint98_linear_6449_68769" x1="30" y1="0" x2="30" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint99_linear_6449_68769"
          x1="30"
          y1="0"
          x2="30"
          y2="74.9816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FED83" />
          <stop offset="1" stopColor="#08872B" />
        </linearGradient>
        <linearGradient id="paint100_linear_6449_68769" x1="30" y1="0" x2="30" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8CF2A6" />
          <stop offset="1" stopColor="#5FED83" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_6449_68769">
          <path d="M0 20H1600V157H0V20Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
